
export const component_types = [
  { label: "Text", value: "text", haveValues: false },
  { label: "Text Field", value: "TextField", haveValues: false },
  { label: "Dropdown", value: "Dropdown", haveValues: true },
  { label: "Radio Group", value: "RadioGroup", haveValues: true },
  { label: "Date Picker", value: "DateValidator", haveValues: false },
  { label: "Time Picker", value: "TimeValidator", haveValues: false },
];

export const officer_types = [
  { label: 'Organization Admin', value: 'Organization Admin' },
  { label: 'Organization Head', value: 'Organization Head' },
  { label: 'Case Manager', value: 'Case Manager' },
  { label: 'Case Officer', value: 'Case Officer' },
  { label: 'First Respondent', value: 'First Respondent' },
  // { label: 'Team Leader First Respondent', value: 'Team Leader First Respondent' },
  // { label: 'Director NCPA', value: 'Director NCPA' },
  // { label: 'Call Center Officer MoWCA', value: 'Call Center Officer MoWCA' },

  //Manegement levels
  // { label: 'Director CID', value: 'Director CID' },
  // { label: 'Deputy Director', value: 'Deputy Director' },
  // { label: 'Department Head', value: 'Department Head' },
  // { label: 'OIC', value: 'OIC' },
];

export const ccid_officer_types = [
  { label: 'Organization Admin', value: 'Organization Admin' }, //
  { label: 'Organization Head', value: 'Organization Head' },//
  { label: 'Director CID', value: 'Director CID' },//Manger dashboard
  { label: 'Deputy Director', value: 'Deputy Director' },//Manger dashboard
  { label: 'Department Head', value: 'Department Head' }, //Manger dashboard
  { label: 'OIC', value: 'OIC' }, // Manager dashboard
  { label: 'Case Officer', value: 'Case Officer' },//
  { label: 'First Respondent', value: 'First Respondent' },//
];

export const bureau_officer_types = [
  { label: 'Organization Admin', value: 'Organization Admin' },//
  { label: 'Organization Head', value: 'Organization Head' },//
  { label: 'Case Manager', value: 'Case Manager' },//
  { label: 'Case Officer', value: 'Case Officer' },//
  { label: 'First Respondent', value: 'First Respondent' },//
];

export const ncpa_officer_types = [
  { label: 'Organization Admin', value: 'Organization Admin' },
  { label: 'Organization Head', value: 'Organization Head' },
  { label: 'Director NCPA', value: 'Director NCPA' },
  { label: 'Team Leader First Respondent', value: 'Team Leader First Respondent' },
  { label: 'Case Officer', value: 'Case Officer' },
  { label: 'Department Head', value: 'Department Head' },
  { label: 'First Respondent', value: 'First Respondent' },
  { label: 'District Officer', value: 'District Officer' },

  //{ label: 'District Officer', value: 'District Officer' },
];

export const slcert_officer_types = [
  { label: 'Organization Admin', value: 'Organization Admin' },//
  { label: 'Organization Head', value: 'Organization Head' },//
  { label: 'Case Manager', value: 'Case Manager' },//
  { label: 'Case Officer', value: 'Case Officer' },//
  { label: 'First Respondent', value: 'First Respondent' },//
];

export const mowca_officer_types = [
  { label: 'Organization Admin', value: 'Organization Admin' },//
  { label: 'Organization Head', value: 'Organization Head' },//
  { label: 'Call Center Officer MoWCA', value: 'Call Center Officer MoWCA' },//manager dashboard
  { label: 'Legal Officer', value: 'Legal Officer' }, //Officer dashboard
  { label: 'Counselling Officer', value: 'Counselling Officer' },//Officer dashboard
  //{ label: 'Call Center & Reporting Officer MoWCA', value: 'Call Center & Reporting Officer MoWCA' },
];

export const reporting_for = [
  { value: "Self / Victim", label: "Self / Victim" },
  { value: "Own Child", label: "Own Child" },
  { value: "Known Child", label: "Known Child" },
  { value: "Known Adult", label: "Known Adult" },
  {
    value: "Unknown Person",
    label: "Unknown Person",
  },
];

export const assignment_type = [
  { label: "Forward", value: "FORWARD" },
  { label: "Transferred", value: "TRANSFER" },
  { label: "Re-Opened", value: "RE-OPENED" },
];

export const transfer_status = [
  { label: "PENDING", value: "PENDING" },
  { label: "ACCEPTED", value: "ACCEPTED" },
];

export const field_types = [
  { label: "Number", value: "Number" },
  { label: "Text", value: "Text" },
];

export const case_type = [
  { label: "FORWARD", value: "FORWARD" },
  { label: "TRANSFER", value: "TRANSFER" },
  { label: "PARTIAL_TRANSFER", value: "PARTIAL_TRANSFER" },
  //  { label: 'ORGANIZATION', value: 'ORGANIZATION' },
];

export const transfer_type = [
  { label: "FULL", value: "FULL" },
  { label: "PARTIAL", value: "PARTIAL" },
];

export const field_validations = [
  { label: "Required", value: "required", allowAddingValue: false },
  {
    label: "Match Regular Expression",
    value: "matchRegexp",
    allowAddingValue: true,
  },
  { label: "Is Email", value: "isEmail", allowAddingValue: false },
  { label: "Is Empty", value: "isEmpty", allowAddingValue: false },
  { label: "Trim", value: "trim", allowAddingValue: false },
  { label: "Is Number", value: "isNumber", allowAddingValue: false },
  { label: "Is Float", value: "isFloat", allowAddingValue: false },
  { label: "Is Positive", value: "isPositive", allowAddingValue: false },
  { label: "Minimum Number", value: "minNumber", allowAddingValue: true },
  { label: "Maximum Number", value: "maxNumber", allowAddingValue: true },
  { label: "Minimum Float", value: "minFloat", allowAddingValue: true },
  { label: "Maximum Float", value: "maxFloat", allowAddingValue: true },
  { label: "Is String", value: "isString", allowAddingValue: false },
  {
    label: "Minimum String Length",
    value: "minStringLength",
    allowAddingValue: true,
  },
  {
    label: "Maximum String Length",
    value: "maxStringLength",
    allowAddingValue: true,
  },
  { label: "Maximum File Size", value: "maxFileSize", allowAddingValue: true },
  {
    label: "Allowed Extensions",
    value: "allowedExtensions",
    allowAddingValue: true,
  },
];

export const evidence_types = [
  { label: "Image", value: "image" },
  { label: "Video", value: "video" },
  { label: "Audio", value: "audio" },
  { label: "Document", value: "document" },
  { label: "Post", value: "post" },
  { label: "Paper", value: "paper" },
  { label: "Screenshot", value: "screenshot" },
  { label: "Email", value: "email" },
  { label: "Message", value: "message" },
  { label: "Other", value: "other" },
];
export const question_for = [
  { label: "Applicant", value: "applicant" },
  { label: "Organization", value: "organization" },
  { label: "Both", value: "both" },
];

export const districts = [
  { label: "Colombo", value: "Colombo" },
  { label: "Gampaha", value: "Gampaha" },
  { label: "Kalutara", value: "Kalutara" },
  { label: "Kandy", value: "Kandy" },
  { label: "Matale", value: "Matale" },
  { label: "Nuwara Eliya", value: "Nuwara Eliya" },
  { label: "Galle", value: "Galle" },
  { label: "Matara", value: "Matara" },
  { label: "Hambantota", value: "Hambantota" },
  { label: "Jaffna", value: "Jaffna" },
  { label: "Kilinochchi", value: "Kilinochchi" },
  { label: "Mannar", value: "Mannar" },
  { label: "Vavuniya", value: "Vavuniya" },
  { label: "Mullaitivu", value: "Mullaitivu" },
  { label: "Trincomalee", value: "Trincomalee" },
  { label: "Batticaloa", value: "Batticaloa" },
  { label: "Ampara", value: "Ampara" },
  { label: "Kurunegala", value: "Kurunegala" },
  { label: "Puttalam", value: "Puttalam" },
  { label: "Anuradhapura", value: "Anuradhapura" },
  { label: "Polonnaruwa", value: "Polonnaruwa" },
  { label: "Badulla", value: "Badulla" },
  { label: "Monaragala", value: "Monaragala" },
  { label: "Ratnapura", value: "Ratnapura" },
  { label: "Kegalle", value: "Kegalle" },
];

export const occupations = [
  { label: 'Government / Semi-Government Sector', value: 'Government / Semi-Government Sector' },
  { label: 'Private Sector', value: 'Private Sector' },
  { label: 'Own Business', value: 'Own Business' },
  { label: 'Self-Employment', value: 'Self-Employment' },
  { label: 'Unemployment', value: 'Unemployment' },
];

export const civil_statuses = [
  { label: 'Single', value: 'Single' },
  { label: 'Married', value: 'Married' },
  { label: 'Divorced', value: 'Divorced' },
  { label: 'Widow', value: 'Widow' },
  { label: 'Living Together', value: 'Living Together' },
  { label: 'Separate', value: 'Separate' },
];

export const ethnicities = [
  { label: 'Sinhala', value: 'Sinhala' },
  { label: 'Sri Lankan Tamil', value: 'Sri Lankan Tamil' },
  { label: 'Indian Tamil', value: 'Indian Tamil' },
  { label: 'Muslim', value: 'Muslim' },
  { label: 'Malay', value: 'Malay' },
  { label: 'Burgher', value: 'Burgher' },
  { label: 'Other', value: 'Other' },
];

export const religions = [
  { label: 'Buddhist', value: 'Buddhist' },
  { label: 'Hindu', value: 'Hindu' },
  { label: 'Islam', value: 'Islam' },
  { label: 'Catholic', value: 'Catholic' },
  { label: 'Christian', value: 'Christian' },
  { label: 'Other', value: 'Other' },
];

export const education_levels = [
  { label: 'No Schooling', value: 'No Schooling' },
  { label: 'Primary', value: 'Primary' },
  { label: 'Secondary', value: 'Secondary' },
  { label: 'GCE (O/Level)', value: 'GCE (O/Level)' },
  { label: 'GCE (A/Level)', value: 'GCE (A/Level)' },
  { label: 'Diploma / Degree Holder', value: 'Diploma / Degree Holder' },
  { label: 'Postgraduate / Masters / M.Phil / Ph.D', value: 'Postgraduate / Masters / M.Phil / Ph.D' },
  { label: 'Other Professional Qualifications', value: 'Other Professional Qualifications' },
];

export const family_types = [
  { label: 'Nuclear Family', value: 'Nuclear Family' },
  { label: 'Extended Family', value: 'Extended Family' },
  { label: 'Remarried Family (stepfamilies)', value: 'Remarried Family (stepfamilies)' },
  { label: 'Single parent (Male/Female)', value: 'Single parent (Male/Female)' },
  { label: 'Childless Families (families without children)', value: 'Childless Families (families without children)' },
];

export const diseaseTypes = [
  { label: 'Chronic/Non-Communicable', value: 'Chronic/Non-Communicable' },
  { label: 'Non-Chronic/Communicable', value: 'Non-Chronic/Communicable' },
];

export const diseasesByType = {
  "Chronic/Non-Communicable": [
    "Diabetes",
    "Hypertension",
    "Heart Disease",
    "Asthma",
    "Cancer",
    "Arthritis",
    "Chronic Kidney Disease",
    "Epilepsy"
  ],
  "Non-Chronic/Communicable": [
    "Dengue",
    "COVID-19",
    "Influenza",
    "Tuberculosis",
    "Chickenpox",
    "Measles",
    "Typhoid",
    "Malaria"
  ]
};

export const disabilityTypes = [
  { label: 'No Disabilities', value: 'No Disabilities' },
  { label: 'Little Disabilities', value: 'Little Disabilities' },
  { label: 'Moderate Disabilities', value: 'Moderate Disabilities' },
  { label: 'Severe Disabilities', value: 'Severe Disabilities' },
  { label: 'Complete Disabilities', value: 'Complete Disabilities' },
];
export const disabilities = [
  { label: 'Sight', value: 'Sight' },
  { label: 'Hearing', value: 'Hearing' },
  { label: 'Physical', value: 'Physical' },
  { label: 'Mental', value: 'Mental' },
];

export const grades = [
  { label: 'Grade 1', value: '1' },
  { label: 'Grade 2', value: '2' },
  { label: 'Grade 3', value: '3' },
  { label: 'Grade 4', value: '4' },
  { label: 'Grade 5', value: '5' },
  { label: 'Grade 6', value: '6' },
  { label: 'Grade 7', value: '7' },
  { label: 'Grade 8', value: '8' },
  { label: 'Grade 9', value: '9' },
  { label: 'Grade 10', value: '10' },
  { label: 'Grade 11', value: '11' },
  { label: 'Grade 12', value: '12' },
  { label: 'Grade 13', value: '13' },
];

export const school_types = [
  { label: "Government Boys School", value: "Government Boys School" },
  { label: "Government Girls School", value: "Government Girls School" },
  { label: "Government Mixed School", value: "Government Mixed School" },
  { label: "Government Girls School with boys in primary or AIL", value: "Government Girls School with boys in primary or AIL" },
  { label: "Government Boys School with girls in primary or AIL", value: "Government Boys School with girls in primary or AIL" },
  { label: "Private Boys School", value: "Private Boys School" },
  { label: "Private Girls School", value: "Private Girls School" },
  { label: "Private Mixed School", value: "Private Mixed School" },
  { label: "Privena Male", value: "Privena Male" },
  { label: "Privena Female", value: "Privena Female" },
  { label: "Pre School", value: "Pre School" },
  { label: "Unknown", value: "Unknown" },
];

export const educational_zones = [

  { label: "Akkaraipattu", value: "Akkaraipattu" },
  { label: "Akuressa", value: "Akuressa" },
  { label: "Ambalangoda", value: "Ambalangoda" },
  { label: "Ampara", value: "Ampara" },
  { label: "Anuradhapura", value: "Anuradhapura" },
  { label: "Badulla", value: "Badulla" },
  { label: "Balangoda", value: "Balangoda" },
  { label: "Bandarawela", value: "Bandarawela" },
  { label: "Batticaloa", value: "Batticaloa" },
  { label: "Batticaloa Central", value: "Batticaloa Central" },
  { label: "Batticaloa West", value: "Batticaloa West" },
  { label: "Bibile", value: "Bibile" },
  { label: "Chilaw", value: "Chilaw" },
  { label: "Colombo", value: "Colombo" },
  { label: "Dehiattakandiya", value: "Dehiattakandiya" },
  { label: "Dehiowita", value: "Dehiowita" },
  { label: "Deniyaya (Morawaka)", value: "Deniyaya (Morawaka)" },
  { label: "Denuwara", value: "Denuwara" },
  { label: "Dimbulagala", value: "Dimbulagala" },
  { label: "Elpitiya", value: "Elpitiya" },
  { label: "Embilipitiya", value: "Embilipitiya" },
  { label: "Galenbindunuwewa", value: "Galenbindunuwewa" },
  { label: "Galewela", value: "Galewela" },
  { label: "Galle", value: "Galle" },
  { label: "Gampaha", value: "Gampaha" },
  { label: "Gampola", value: "Gampola" },
  { label: "Giriulla", value: "Giriulla" },
  { label: "Hambantota", value: "Hambantota" },
  { label: "Hanguranketha", value: "Hanguranketha" },
  { label: "Hatton", value: "Hatton" },
  { label: "Hingurakgoda", value: "Hingurakgoda" },
  { label: "Homagama", value: "Homagama" },
  { label: "Horana", value: "Horana" },
  { label: "Ibbagamuwa", value: "Ibbagamuwa" },
  { label: "Islands", value: "Islands" },
  { label: "Jaffna", value: "Jaffna" },
  { label: "Kalkudah", value: "Kalkudah" },
  { label: "Kalmunai", value: "Kalmunai" },
  { label: "Kalutara", value: "Kalutara" },
  { label: "Kandy", value: "Kandy" },
  { label: "Kantale", value: "Kantale" },
  { label: "Katugastota", value: "Katugastota" },
  { label: "Kebithigollewa", value: "Kebithigollewa" },
  { label: "Kegalle", value: "Kegalle" },
  { label: "Kekirawa", value: "Kekirawa" },
  { label: "Kelaniya", value: "Kelaniya" },
  { label: "Kilinochchi", value: "Kilinochchi" },
  { label: "Kinniya", value: "Kinniya" },
  { label: "Kotmale", value: "Kotmale" },
  { label: "Kuliyapitiya", value: "Kuliyapitiya" },
  { label: "Kurunegala", value: "Kurunegala" },
  { label: "Madhu", value: "Madhu" },
  { label: "Mahaoya", value: "Mahaoya" },
  { label: "Mahiyanganaya", value: "Mahiyanganaya" },
  { label: "Maho", value: "Maho" },
  { label: "Mannar", value: "Mannar" },
  { label: "Matale", value: "Matale" },
  { label: "Matara", value: "Matara" },
  { label: "Matugama", value: "Matugama" },
  { label: "Mawanella", value: "Mawanella" },
  { label: "Minuwangoda", value: "Minuwangoda" },
  { label: "Monaragala", value: "Monaragala" },
  { label: "Mulatiyana (Hakmana)", value: "Mulatiyana (Hakmana)" },
  { label: "Mullativu", value: "Mullativu" },
  { label: "Mutur", value: "Mutur" },
  { label: "Naula", value: "Naula" },
  { label: "Negombo", value: "Negombo" },
  { label: "Nikaweratiya", value: "Nikaweratiya" },
  { label: "Nivitigala", value: "Nivitigala" },
  { label: "Nuwara Eliya", value: "Nuwara Eliya" },
  { label: "Paddrippu", value: "Paddrippu" },
  { label: "Passara", value: "Passara" },
  { label: "Piliyandala", value: "Piliyandala" },
  { label: "Polonnaruwa", value: "Polonnaruwa" },
  { label: "Puttalam", value: "Puttalam" },
  { label: "Ratnapura", value: "Ratnapura" },
  { label: "Sammanthurai", value: "Sammanthurai" },
  { label: "Sri Jayawardenapura", value: "Sri Jayawardenapura" },
  { label: "Tangalle", value: "Tangalle" },
  { label: "Teldeniya", value: "Teldeniya" },
  { label: "Thambuttegama", value: "Thambuttegama" },
  { label: "Thanamalvila", value: "Thanamalvila" },
  { label: "Thenmarachchi", value: "Thenmarachchi" },
  { label: "Thirukkovil", value: "Thirukkovil" },
  { label: "Thunukka", value: "Thunukka" },
  { label: "Trincomalee", value: "Trincomalee" },
  { label: "Trincomalee North", value: "Trincomalee North" },
  { label: "Udugama", value: "Udugama" },
  { label: "Vadamarachchi", value: "Vadamarachchi" },
  { label: "Valikamam", value: "Valikamam" },
  { label: "Vavuniya North", value: "Vavuniya North" },
  { label: "Vavuniya South", value: "Vavuniya South" },
  { label: "Viyaluwa", value: "Viyaluwa" },
  { label: "Walapane", value: "Walapane" },
  { label: "Walasmulla", value: "Walasmulla" },
  { label: "Wattegama", value: "Wattegama" },
  { label: "Welimada", value: "Welimada" },
  { label: "Wellawaya", value: "Wellawaya" },
  { label: "Wilgamuwa", value: "Wilgamuwa" }
];

export const victim_affected = [
  { value: "Self / Victim", label: "Self / Victim" },
  { value: "Own Child", label: "Own Child" },
  { value: "Known Child", label: "Known Child" },
  { value: "Known Adult", label: "Known Adult" },
  {
    value: "Unknown Person",
    label: "Unknown Person",
  },
];

export const officerReportCaseOrganizations = [
  {
    label: "National Child Protection Authority/1929",
    value: "National Child Protection Authority/1929",
  },
  { label: "Divisional Secretariate", value: "Divisional Secretariate" },
  { label: "Legal Aid Commission", value: "Legal Aid Commission" },
  { label: "Quazhi Court", value: "Quazhi Court" },
  { label: "Police", value: "Police" },
  { label: "Sri Lanka Cert", value: "Sri Lanka Cert" },
  { label: "Hithawathi", value: "Hithawathi" },
  { label: "Mithuru Piyasa", value: "Mithuru Piyasa" },
  { label: "Women In Need", value: "Women In Need" },
  {
    label: "1926 National Mental Health Helpline",
    value: "1926 National Mental Health Helpline",
  },
  {
    label: "National Secretariat for Elder",
    value: "National Secretariat for Elder",
  },
  {
    label: "Ministry of Social Services",
    value: "Ministry of Social Services",
  },
  { label: "MOH/Hospital", value: "MOH/Hospital" },
  { label: "Other Institutes", value: "Other Institutes" },
];

export const time_periods = [
  { label: "Within a week", value: "Within a week" },
  { label: "Within a month", value: "Within a month" },
  { label: "Below 1 Year", value: "Below 1 Year" },
  { label: "1-5 Years", value: "1-5 Years" },
  { label: "5-10 Years", value: "5-10 Years" },
  { label: "More than 10 Years", value: "More than 10 Years" },
  { label: "Other (Select Date)", value: "Other" },
];

export const case_locations = [
  { label: "Domestic", value: "Domestic" },
  { label: "Community", value: "Community" },
  { label: "Workplace", value: "Workplace" },
  { label: "Public place", value: "Public place" },
  { label: "Transport", value: "Transport" },
  { label: "Other", value: "Other" },
];

export const case_priority = [
  { label: "Average", value: "average" },
  { label: "Urgent", value: "urgent" },
  { label: "Very Urgent", value: "very_urgent" },
];

export const victim_occupation = [
  { label: "Government / Semi-Government Sector", value: "Government / Semi-Government Sector" },
  { label: "Private Sector", value: "Private Sector" },
  { label: "Own Business", value: "Own Business" },
  { label: "Self-Employment", value: "Self-Employment" },
  { label: "Unemployment", value: "Unemployment" },
];
export const victim_civil_status = [
  { label: "Single", value: "Single" },
  { label: "Married", value: "Married" },
  { label: "Divorced", value: "Divorced" },
  { label: "Widow", value: "Widow" },
  { label: "Living Together", value: "Living Together" },
  { label: "Separate", value: "Separate" },
];

export const victim_ethnicity = [
  { label: "Sinhala", value: "Sinhala" },
  { label: "Sri Lankan Tamil", value: "Sri Lankan Tamil" },
  { label: "Indian Tamil", value: "Indian Tamil" },
  { label: "Muslim", value: "Muslim" },
  { label: "Malay", value: "Malay" },
  { label: "Burgher", value: "Burgher" },
  { label: "Other", value: "Other" },
];

export const victim_religion = [
  { label: "Buddhist", value: "Buddhist" },
  { label: "Hindu", value: "Hindu" },
  { label: "Islam", value: "Islam" },
  { label: "Catholic", value: "Catholic" },
  { label: "Christian", value: "Christian" },
  { label: "Other", value: "Other" },
];

export const victim_highest_education_levels = [
  { label: "No Schooling", value: "No Schooling" },
  { label: "Primary", value: "Primary" },
  { label: "Secondary", value: "Secondary" },
  { label: "GCE (O/Level)", value: "GCE (O/Level)" },
  { label: "GCE (A/Level)", value: "GCE (A/Level)" },
  { label: "Diploma / Degree Holder", value: "Diploma / Degree Holder" },
  { label: "Postgraduate / Masters / M.Phil / Ph.D", value: "Postgraduate / Masters / M.Phil / Ph.D" },
  { label: "Other Professional Qualifications", value: "Other Professional Qualifications" },
];

export const victim_family_types = [
  { label: "Nuclear Family", value: "Nuclear Family" },
  { label: "Extended Family", value: "Extended Family" },
  { label: "Remarried Family (Stepfamilies)", value: "Remarried Family (Stepfamilies)" },
  { label: "Single Parent (Male)", value: "Single Parent (Male)" },
  { label: "Single Parent (Female)", value: "Single Parent (Female)" },
  { label: "Childless Families (Families without children)", value: "Childless Families (Families without children)" },
];

export const victim_child_disability_status = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const close_reason_type = [
  { label: 'Victim', value: 'VICTIM' },
  { label: 'Officer', value: 'OFFICER' },
  { label: 'Forward', value: 'FORWARD' },
];

export const evidence_request_status = [
  { label: 'Provided', value: 'Provided' },
  { label: 'Not Given', value: 'Not Given' },
];

